import React, { Component } from 'react';
//import Breadcrumb from "../common/breadcrumb";
import HeaderWelcome from '../common/headers/header-welcome';
import { Link } from 'react-router-dom';
import AuthService from '../services/auth.service';
import ApiService from '../services/api.service';
import CampaignService from '../services/campaign.service';
import {
  removeFromCart,
  incrementQty,
  decrementQty,
  getFromPurchaseRefered,
  getFromCartUser
} from '../../actions';
import store from '../../store';
import Slider from 'react-slick';
import BannersList from '../layouts/common/list-banners';
import CampaignPopup from '../common/campaign-popup';
import Swal from 'sweetalert2';
import Select from 'react-select';
import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import 'react-datepicker/dist/react-datepicker.css';
registerLocale('es', es);

class Welcome extends Component {
  constructor(props) {
    super(props);
    this.handleHoverOut = this.handleHoverOut.bind(this);
    this.handleHover1 = this.handleHover1.bind(this);
    this.handleHover2 = this.handleHover2.bind(this);
    this.handleProfileCampaignSubmit = this.handleProfileCampaignSubmit.bind(
      this
    );
    this.sliderRef = React.createRef();
    this.state = {
      isHovered1: false,
      isHovered2: false,
      isHovered: 0,
      user_name: '',
      data_categ_parents: [],
      amount_cash: 0,
      data_banners: [],
      alias: '',
      showCampaignPopup: false,
      campaignData: null,
      showProfileCampaignPopup: false,
      campaignBirthdate: null,
      campaignGender: null,
      campaignAddresses: [],
      campaignAddressesUpdated: {},
      campaignSubmitting: false,
      campaignUserProfile: null,
      campaignRetryCount: 0
    };
  }

  UNSAFE_componentWillMount() {
    var user = AuthService.getCurrentUser();
    if (user) {
      if (user.name) {
        this.setState({
          user_name: user.name,
          alias: user.alias
        });
      }
      document.body.style = `background-color: #161616;font-family: 'Work Sans'`;
      this.checkOpen();
      this.getRefOrders();
      this.checkActiveCampaign();
      this.checkProfileCampaign();
    } else {
      this.props.history.push('/login');
    }
  }

  handleHover = id => {
    this.setState({
      isHovered: id
    });
  };

  handleHoverOut(e) {
    this.setState({
      isHovered: 0
    });
  }

  handleHover1(e) {
    this.setState({
      isHovered1: !this.state.isHovered1
    });
  }

  handleHover2(e) {
    this.setState(prevState => ({
      isHovered2: !prevState.isHovered2
    }));
  }

  checkOpen() {
    var user = AuthService.getCurrentUser();
    ApiService.checkOpen(user.token).then(
      res => {
        if (res && res.status == 'success') {
          if (res.data.option_value == 'NO') {
            if (window.location.pathname != '/closed') {
              this.props.history.push('/closed');
            }
          } else {
            this.getCategParent();
            this.getCash();
            this.getBanners();
          }
        } else {
          this.props.history.push('/closed');
          window.location.reload();
        }
      },
      error => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }

  getRefOrders() {
    var user = AuthService.getCurrentUser();
    ApiService.getReferredOrders(user.token, user.token_order, user.id).then(
      res => {
        if (res && res.status == 'success') {
          store.dispatch(getFromPurchaseRefered(res.data));

          if (res.carts_data && res.carts_data.length === 0) {
            localStorage.removeItem('hasCheckedOpen');
          }

          store.dispatch(getFromCartUser(res.carts_data));
        }
      },
      error => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }

  getCategParent() {
    var user = AuthService.getCurrentUser();
    document.getElementsByClassName('page-loader')[0].style.display = 'flex';
    ApiService.getCategParents(user.token, 0).then(
      res => {
        if (res && res.status == 'success') {
          //this.setState({ data_categ_parents: this.showImage(res.data) });
          this.setState({ data_categ_parents: res.data });
          if (res.data.length > 0) {
            document.getElementsByClassName('page-loader')[0].style.display =
              'none';
          }
          //this.setState({ order_results:res.data });
        } else {
          document.getElementsByClassName('page-loader')[0].style.display =
            'none';
        }
      },
      error => {
        document.getElementsByClassName('page-loader')[0].style.display =
          'none';
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }

  getCash() {
    var user = AuthService.getCurrentUser();
    AuthService.getCash(user.token).then(
      res => {
        if (res && res.status == 'success') {
          let amount_cash =
            res && res.data && res.data.amount_cash
              ? Math.round(res.data.amount_cash * 100) / 100
              : 0;
          this.setState({ amount_cash: amount_cash });
        }
      },
      error => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }

  getBanners() {
    var user = AuthService.getCurrentUser();
    ApiService.getBanners(user.token).then(
      res => {
        if (res && res.status == 'success') {
          this.setState({ data_banners: res.data });
          /*let amount_cash = res && res.data && res.data.amount_cash  ? Math.round(res.data.amount_cash*100)/100 : 0
                    this.setState({ amount_cash: amount_cash });*/
        }
      },
      error => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }

  handleImageLoaded() {
    document.getElementsByClassName('page-loader')[0].style.display = 'none';
    //this.setState({ imageStatus: "loaded" });
  }

  checkProfileCampaign() {
    var user = AuthService.getCurrentUser();
    if (!user) return;
    Promise.all([
      ApiService.getProfileCampaignStatus(user.token),
      ApiService.getUserAddresses(user.token, user.id),
      ApiService.getUserDetails(user.token, user.id)
    ])
      .then(
        function(results) {
          var campaignRes = results[0];
          var addrRes = results[1];
          var profileRes = results[2];
          if (
            campaignRes &&
            campaignRes.status === 'success' &&
            campaignRes.should_show
          ) {
            ApiService.postProfileCampaignShown(user.token).catch(function() {});
            var addresses =
              addrRes && addrRes.status === 'success' && addrRes.data
                ? addrRes.data
                : [];
            var profile =
              profileRes && profileRes.status === 'success' && profileRes.data
                ? profileRes.data
                : null;
            this.setState({
              campaignAddresses: addresses,
              campaignUserProfile: profile,
              showProfileCampaignPopup: true
            });
          }
        }.bind(this)
      )
      .catch(function() {});
  }

  handleProfileCampaignSubmit(e) {
    e.preventDefault();
    var user = AuthService.getCurrentUser();
    var self = this;

    // Validaciones requeridas para la campaña
    var swalOpts = { customClass: { container: 'swal-over-popup' } };
    if (!this.state.campaignBirthdate) {
      Swal.fire(
        Object.assign({}, swalOpts, {
          icon: 'warning',
          title: 'Campo requerido',
          text: 'Por favor ingresa tu fecha de cumpleaños.'
        })
      );
      return;
    }
    if (!this.state.campaignGender) {
      Swal.fire(
        Object.assign({}, swalOpts, {
          icon: 'warning',
          title: 'Campo requerido',
          text: 'Por favor selecciona tu género.'
        })
      );
      return;
    }
    var missingLeave = this.state.campaignAddresses.some(function(addr) {
      var upd = self.state.campaignAddressesUpdated[addr.id] || {};
      var val =
        upd.leave_your_order !== undefined
          ? upd.leave_your_order
          : addr.leave_your_order || '';
      return !val;
    });
    if (missingLeave) {
      Swal.fire(
        Object.assign({}, swalOpts, {
          icon: 'warning',
          title: 'Campo requerido',
          text:
            'Por favor indica con quién dejamos el pedido en cada dirección.'
        })
      );
      return;
    }

    self.setState({ campaignSubmitting: true });

    var dataUser = {
      birthdate: this.state.campaignBirthdate
        ? this.state.campaignBirthdate.toISOString().split('T')[0]
        : null,
      gender: this.state.campaignGender ? this.state.campaignGender.value : null
    };

    function closePopup() {
      self.setState({ campaignSubmitting: false, showProfileCampaignPopup: false, campaignRetryCount: 0 });
    }

    function logError(step, detail) {
      ApiService.postProfileCampaignError(user.token, { step: step, detail: detail }).catch(function() {});
    }

    function handleError(step, detail) {
      var currentRetry = self.state.campaignRetryCount;
      if (currentRetry < 1) {
        self.setState({ campaignSubmitting: false, campaignRetryCount: currentRetry + 1 });
        Swal.fire(Object.assign({}, swalOpts, {
          icon: 'error',
          title: 'Error al guardar',
          text: 'Hubo un problema al guardar tus datos. Por favor intenta de nuevo.'
        }));
      } else {
        logError(step, detail);
        closePopup();
      }
    }

    ApiService.updateUserDataCampaign(user.token, dataUser)
      .then(function(res) {
        if (res && res.status === 'success') {
          var updates = self.state.campaignAddressesUpdated;
          var addressPromises = self.state.campaignAddresses.map(function(addr) {
            var upd = updates[addr.id] || {};
            var newLeaveYourOrder =
              upd.leave_your_order !== undefined
                ? upd.leave_your_order
                : addr.leave_your_order;
            var newBeforeHour =
              upd.before_hour !== undefined
                ? upd.before_hour
                : addr.before_hour || false;
            if (newLeaveYourOrder !== 'Conserje') newBeforeHour = false;
            return ApiService.updateAddressDataCampaign(user.token, {
              id_address: addr.id,
              type_address: addr.type_address,
              leave_your_order: newLeaveYourOrder,
              before_hour: newBeforeHour,
              address: addr.address,
              number: addr.number,
              interior: addr.interior,
              url_google: addr.url_google,
              ubigeo: addr.ubigeo,
              district: addr.district,
              id_user: user.id
            });
          });

          Promise.all(addressPromises)
            .then(function(results) {
              var failed = results.find(function(r) { return !r || r.status !== 'success'; });
              if (failed) {
                handleError('update_addresses', failed && failed.message ? failed.message : 'Error al actualizar dirección');
                return;
              }
              return ApiService.postProfileCampaignComplete(user.token)
                .then(function() {
                  closePopup();
                  Swal.fire({
                    icon: 'success',
                    title: '¡Gracias!',
                    text: 'Tus datos han sido enviados para revisión. Se verán reflejados en máximo 24 horas.'
                  });
                })
                .catch(function(err) {
                  handleError('complete', err && err.message ? err.message : 'Error al completar campaña');
                });
            })
            .catch(function(err) {
              handleError('update_addresses', err && err.message ? err.message : 'Error al actualizar direcciones');
            });
        } else {
          handleError('update_user', res && res.message ? res.message : 'Respuesta no exitosa del servidor');
        }
      })
      .catch(function(err) {
        handleError('update_user_network', err && err.message ? err.message : 'Error de red');
      });
  }

  checkActiveCampaign() {
    var user = AuthService.getCurrentUser();
    if (!user || !user.id) return;

    const campaignShownKey = `campaign_shown_${user.id}`;
    CampaignService.getActiveCampaign(user.id)
      .then(res => {
        if (res && res.status === 'success' && res.data) {
          this.setState({
            showCampaignPopup: true,
            campaignData: res.data
          });
          sessionStorage.setItem(campaignShownKey, 'true');
        }
      })
      .catch(error => {
      });
  }

  handleCloseCampaignPopup = () => {
    this.setState(
      {
        showCampaignPopup: false,
        campaignData: null
      },
      () => {
        // Reinicializar el slider después de cerrar el modal
        if (this.sliderRef.current) {
          setTimeout(() => {
            this.sliderRef.current.slickGoTo(0);
          }, 100);
        }
      }
    );
  };

  render() {
    document.body.classList.add('dark');
    const settings = {
      dots: true,
      infinite: true,
      speed: 2000,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000
    };
    return (
      <div>
        {/* Popup de campaña WhatsApp */}
        {this.state.showCampaignPopup && this.state.campaignData && (
          <CampaignPopup
            campaign={this.state.campaignData.campaign}
            banner={this.state.campaignData.banner}
            products={this.state.campaignData.products}
            symbol="S/. "
            onClose={this.handleCloseCampaignPopup}
          />
        )}

        {/* Popup de actualización de datos de perfil */}
        {this.state.showProfileCampaignPopup &&
          (() => {
            const customStyles = {
              option: (styles, { isFocused }) => ({
                ...styles,
                backgroundColor: '#161616',
                color: '#F8EEE1'
              }),
              control: base => ({
                ...base,
                background: '#161616',
                border: '2px solid #F8EEE1',
                borderRadius: 30
              }),
              singleValue: base => ({
                ...base,
                color: '#F8EEE1'
              }),
              placeholder: base => ({
                ...base,
                color: '#888'
              }),
              input: base => ({
                ...base,
                color: '#F8EEE1'
              }),
              menu: base => ({
                ...base,
                backgroundColor: '#161616',
                zIndex: 9999
              }),
              menuList: base => ({ ...base, backgroundColor: '#161616' })
            };
            const dataLeaveYourOrder = [
              { value: 'Conserje', label: 'Conserje' },
              { value: 'Cliente recoge', label: 'Cliente recoge' }
            ];
            const dataGenero = [
              { value: 'Masculino', label: 'Masculino' },
              { value: 'Femenino', label: 'Femenino' },
              { value: 'Prefiero no decirlo', label: 'Prefiero no decirlo' }
            ];
            return (
              <div
                className="ver-modal-overlay add-address-overlay"
                style={{ display: 'block', overflowY: 'auto', zIndex: 9999999 }}
              >
                <div
                  style={{
                    minHeight: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    position: 'relative',
                    padding: '4rem 20px 2rem'
                  }}
                >
                  <div style={{ width: '100%', maxWidth: '560px' }}>
                    <div style={{ padding: '0px 10px' }}>
                      <div className="row" style={{ marginBottom: '2rem' }}>
                        <div className="col-md-12">
                          <div className="page-title title-modal-profile">
                            <label className="text-confirm-order">
                              ACTUALIZA TU INFORMACIÓN
                            </label>
                          </div>
                        </div>
                        <p className="text-center mt-2">
                          Actualiza tus datos y recibe 5 soles en créditos!
                          Además recibe bonos por tu cumpleaños
                        </p>
                      </div>

                      {/* Fecha de cumpleaños */}
                      <div
                        className="row check-out row-check-date"
                        style={{ marginBottom: '1rem' }}
                      >
                        <div
                          className="form-group col-md-12"
                          style={{ maxWidth: '100%', flex: 'auto' }}
                        >
                          <div
                            className="field-label"
                            style={{ marginBottom: '10px' }}
                          >
                            FECHA DE CUMPLEAÑOS
                          </div>
                          <DatePicker
                            selected={this.state.campaignBirthdate}
                            onChange={date =>
                              this.setState({ campaignBirthdate: date })
                            }
                            locale="es"
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Selecciona tu fecha"
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            maxDate={new Date()}
                            openToDate={this.state.campaignBirthdate || new Date(new Date().setFullYear(new Date().getFullYear() - 18))}
                            yearDropdownItemNumber={80}
                            scrollableYearDropdown
                            className="ver-datepicker-input"
                            wrapperClassName="ver-datepicker-wrapper"
                            popperPlacement="bottom-start"
                            popperModifiers={[{ name: 'offset', options: { offset: [0, 4] } }]}
                          />
                        </div>
                      </div>

                      {/* Género */}
                      <div
                        className="row check-out row-check-date"
                        style={{ marginBottom: '1rem' }}
                      >
                        <div
                          className="form-group col-md-12"
                          style={{ maxWidth: '100%', flex: 'auto' }}
                        >
                          <div
                            className="field-label"
                            style={{ marginBottom: '10px' }}
                          >
                            GÉNERO
                          </div>
                          <Select
                            value={this.state.campaignGender}
                            onChange={val =>
                              this.setState({ campaignGender: val })
                            }
                            options={dataGenero}
                            placeholder="Selecciona una opción"
                            styles={customStyles}
                            isSearchable={false}
                          />
                        </div>
                      </div>

                      {/* Direcciones */}
                      {this.state.campaignAddresses.length > 0 && (
                        <div style={{ marginBottom: '1rem' }}>
                          <div
                            className="field-label"
                            style={{ marginBottom: '10px' }}
                          >
                            MIS DIRECCIONES
                          </div>
                          {this.state.campaignAddresses.map(addr => {
                            var upd =
                              this.state.campaignAddressesUpdated[addr.id] ||
                              {};
                            var currentLeaveYourOrder =
                              upd.leave_your_order !== undefined
                                ? upd.leave_your_order
                                : addr.leave_your_order || '';
                            var currentBeforeHour =
                              upd.before_hour !== undefined
                                ? upd.before_hour
                                : addr.before_hour || false;
                            var selectedLeave =
                              dataLeaveYourOrder.find(function(o) {
                                return o.value === currentLeaveYourOrder;
                              }) || null;
                            return (
                              <div
                                key={addr.id}
                                style={{
                                  border: '1px solid #F8EEE1',
                                  borderRadius: '8px',
                                  padding: '1rem',
                                  marginBottom: '1rem'
                                }}
                              >
                                <div
                                  className="field-label"
                                  style={{
                                    marginBottom: '8px',
                                    fontSize: '0.85rem'
                                  }}
                                >
                                  {addr.type_address} {addr.address}{' '}
                                  {addr.number}
                                  {addr.interior
                                    ? ' Int. ' + addr.interior
                                    : ''}{' '}
                                  — {addr.district}
                                </div>
                                <div
                                  className="row check-out row-check-date"
                                  style={{ marginBottom: '0.5rem' }}
                                >
                                  <div
                                    className="form-group col-md-12"
                                    style={{ maxWidth: '100%', flex: 'auto' }}
                                  >
                                    <div
                                      className="field-label"
                                      style={{
                                        marginBottom: '10px',
                                        fontWeight: 'normal',
                                        fontSize: '0.85rem'
                                      }}
                                    >
                                      ¿CON QUIÉN DEJAMOS TU PEDIDO?
                                    </div>
                                    <Select
                                      value={selectedLeave}
                                      onChange={val => {
                                        var updated = Object.assign(
                                          {},
                                          this.state.campaignAddressesUpdated
                                        );
                                        var prev = updated[addr.id] || {};
                                        updated[addr.id] = Object.assign(
                                          {},
                                          prev,
                                          {
                                            leave_your_order: val
                                              ? val.value
                                              : ''
                                          }
                                        );
                                        this.setState({
                                          campaignAddressesUpdated: updated
                                        });
                                      }}
                                      options={dataLeaveYourOrder}
                                      placeholder="Selecciona una opción"
                                      styles={customStyles}
                                      isSearchable={false}
                                    />
                                  </div>
                                </div>
                                {currentLeaveYourOrder === 'Conserje' && (
                                  <label
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '0.5rem',
                                      cursor: 'pointer',
                                      color: '#F8EEE1',
                                      fontSize: '0.88rem',
                                      marginTop: '0.5rem'
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      style={{
                                        width: '18px',
                                        height: '18px',
                                        accentColor: '#12DB6F',
                                        flexShrink: 0
                                      }}
                                      checked={currentBeforeHour}
                                      onChange={e => {
                                        var updated = Object.assign(
                                          {},
                                          this.state.campaignAddressesUpdated
                                        );
                                        var prev = updated[addr.id] || {};
                                        updated[addr.id] = Object.assign(
                                          {},
                                          prev,
                                          { before_hour: e.target.checked }
                                        );
                                        this.setState({
                                          campaignAddressesUpdated: updated
                                        });
                                      }}
                                    />
                                    Pueden dejar el pedido antes de la hora
                                    acordada
                                  </label>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      )}

                      {/* Botones */}
                      <div
                        className="row check-out row-check-date"
                        style={{ marginBottom: '1rem' }}
                      >
                        <div
                          className="form-group col-md-12"
                          style={{ maxWidth: '100%', flex: 'auto' }}
                        >
                          <button
                            className="ver-btn-solid btn btn-save-address btn-primary"
                            style={{
                              width: '100%',
                              marginBottom: '0.8rem',
                              opacity: this.state.campaignSubmitting ? 0.6 : 1
                            }}
                            disabled={this.state.campaignSubmitting}
                            onClick={e => this.handleProfileCampaignSubmit(e)}
                          >
                            {this.state.campaignSubmitting
                              ? 'GUARDANDO...'
                              : 'GUARDAR'}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })()}

        <div className="sup-content-welcome">
          <div className="container container-welcome">
            {/*<h3>Login</h3>*/}
            <div className="div-header-welcome">
              <HeaderWelcome
                logoName={'ver_logo.png'}
                showNav={true}
                homeView={true}
                userName={
                  this.state.alias ? this.state.alias : this.state.user_name
                }
              />
            </div>
            <div className="theme-welcome">
              <div className="row-home title-theme-welcome">
                <div className="title-welcome">
                  <div className="image-left-welcome">
                    <img src="/assets/images/EMOJI_TREBOL.png"></img>
                  </div>
                  <label style={{ textTransform: 'uppercase' }}>
                    HOLA{' '}
                    {this.state.alias ? this.state.alias : this.state.user_name}
                  </label>
                </div>
              </div>

              {this.state.data_banners.length == 0 ? (
                ''
              ) : this.state.data_banners.length == 1 ? (
                <div className="col-lg-12 center-slider border-0 container-banners one-banner">
                  <div>
                    <Slider
                      ref={this.sliderRef}
                      {...settings}
                      className="offer-slider slide-1"
                    >
                      {this.state.data_banners.map((banner, index) => (
                        <div key={index}>
                          <BannersList product={banner} key={index} />
                        </div>
                      ))}
                    </Slider>
                  </div>
                </div>
              ) : (
                <div className="col-lg-12 center-slider border-0 container-banners">
                  <div>
                    <Slider
                      ref={this.sliderRef}
                      {...settings}
                      className="offer-slider slide-1"
                    >
                      {this.state.data_banners.map((banner, index) => (
                        <div key={index}>
                          <BannersList product={banner} key={index} />
                        </div>
                      ))}
                    </Slider>
                  </div>
                </div>
              )}

              <div
                className="row-home row-credit-welcome"
                style={{ display: 'flex', flexWrap: 'wrap' }}
              >
                <div>
                  <div className="credit-welcome">
                    TU CRÉDITO ES:
                    <label style={{ marginLeft: '10px' }}>
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/icon/credit.png`}
                        alt=""
                        className="img-fluid"
                        style={{ position: 'relative', bottom: '2px' }}
                      />{' '}
                      {this.state.amount_cash}
                    </label>
                  </div>
                </div>
              </div>
              <div className="container-items-welcome row-items-welcome">
                {this.state.data_categ_parents.map((item, index) => {
                  var urlTemplate = '';
                  if (item.template == 'TEMPLATE1') {
                    urlTemplate = 'products/' + item.id;
                  } else if (item.template == 'TEMPLATE2') {
                    urlTemplate = 'categProducts/' + item.id;
                  } else {
                    urlTemplate = 'accesories/' + item.id;
                  }
                  return (
                    <Link
                      key={index}
                      to={`${process.env.PUBLIC_URL}/${urlTemplate}`}
                      className={
                        this.state.data_categ_parents.length % 3 == 0 &&
                        (index + 1) % 3 == 0
                          ? 'card-categ third-element-parent'
                          : 'card-categ categ-parent'
                      }
                    >
                      <div
                        className={
                          this.state.isHovered == item.id
                            ? 'item-welcome-hover'
                            : 'item-welcome'
                        }
                        onMouseOver={() => this.handleHover(item.id)}
                        onMouseOut={this.handleHoverOut}
                      >
                        <img
                          src={
                            `${process.env.REACT_APP_URL_FILES}images/categories/` +
                            item.background_url
                          }
                          onLoad={this.handleImageLoaded.bind(this)}
                        />
                        <label
                          className="item-name-welcome"
                          style={{ textTransform: 'uppercase' }}
                        >
                          {item.name}
                        </label>
                      </div>
                    </Link>
                  );
                })}
              </div>

              <div className="row row-thanks-welcome">
                <label className="thanks-welcome">
                  Gracias por seguir acompañándonos cada día.
                </label>
              </div>
            </div>
          </div>
          <div className="image-right-welcome img-rihgt-1">
            <img src="/assets/images/plants3.jpg"></img>
          </div>
          <div className="image-right-welcome img-rihgt-2">
            <img src="/assets/images/plants4.jpg"></img>
          </div>
        </div>
      </div>
    );
  }
}

export default Welcome;
